export default "__VITE_ASSET__tFp0PHTr__"